import { render, staticRenderFns } from "./Daifa.vue?vue&type=template&id=b33ace3e&scoped=true&"
import script from "./Daifa.vue?vue&type=script&lang=js&"
export * from "./Daifa.vue?vue&type=script&lang=js&"
import style0 from "./Daifa.vue?vue&type=style&index=0&id=b33ace3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b33ace3e",
  null
  
)

export default component.exports